'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _Code;
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Entry.STATEMENT = 0;
Entry.PARAM = -1;
Entry.Code = (_Code = /*#__PURE__*/function () {
  function Code(code, object) {
    (0, _classCallCheck2["default"])(this, Code);
    (0, _defineProperty2["default"])(this, "schema", {
      view: null,
      board: null
    });
    (0, _defineProperty2["default"])(this, "doDestroyThread", this.destroyThread);
    Entry.Model(this, false);
    this.id = Entry.generateHash();
    if (object) {
      this.object = object;
    }
    this._data = new Entry.Collection();
    this._eventMap = {};
    this._blockMap = {};
    this.executors = [];
    this.watchEvent = new Entry.Event(this);
    this.executeEndEvent = new Entry.Event(this);
    this.changeEvent = new Entry.Event(this);
    this.changeEvent.attach(this, this._handleChange);
    this._maxZIndex = 0;
    this.load(code);
  }
  return (0, _createClass2["default"])(Code, [{
    key: "load",
    value: function load(code) {
      var _this = this;
      if (Entry.engine && Entry.engine.isState('run')) {
        return;
      }
      this.clear();
      var parseCode = Array.isArray(code) ? code : JSON.parse(code);
      parseCode.forEach(function (t) {
        if (Array.isArray(t) && t.length > 1 && (t === null || t === void 0 ? void 0 : t[0].type) === 'function_create') {
          if (!t[0].statements) {
            t[0].statements = [];
          }
          t[0].statements.push(t.splice(1, t.length));
        }
        var thread = new Entry.Thread(t, _this);
        if (thread.hasData()) {
          _this._data.push(thread);
        }
      });
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      var isNotForce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      for (var i = this._data.length - 1; i >= 0; i--) {
        this._data[i].destroy(false, isNotForce);
      }
      this.clearExecutors();
    }
  }, {
    key: "createView",
    value: function createView(board) {
      if (this.view === null) {
        this.set({
          view: new Entry.CodeView(this, board),
          board: board
        });
      } else {
        this.set({
          board: board
        });
        board.bindCodeView(this.view);
      }
    }
  }, {
    key: "destroyView",
    value: function destroyView() {
      if (!this.view) {
        return;
      }
      this.view.destroy();
      this.set({
        view: null
      });
    }
  }, {
    key: "recreateView",
    value: function recreateView() {
      if (!this.view) {
        return;
      }
      this.destroyView();
      this.set({
        view: new Entry.CodeView(this, this.board),
        board: this.board
      });
    }
  }, {
    key: "registerEvent",
    value: function registerEvent(block, eventType) {
      var eventMap = this._eventMap;
      if (!eventMap[eventType]) {
        eventMap[eventType] = [];
      }
      eventMap[eventType].push(block);
    }
  }, {
    key: "unregisterEvent",
    value: function unregisterEvent(block, eventType) {
      var blocks = this._eventMap[eventType];
      if (_.isEmpty(blocks)) {
        return;
      }
      var index = blocks.indexOf(block);
      if (index < 0) {
        return;
      }
      blocks.splice(index, 1);
    }
  }, {
    key: "raiseEvent",
    value: function raiseEvent(eventType, entity, value) {
      var blocks = this._eventMap[eventType];
      if (blocks === undefined) {
        return;
      }
      var executors = [];
      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        var pointer = block.pointer();
        if (pointer[3] !== 0 || pointer.length !== 4) {
          continue;
        }
        if (value === undefined || block.params.indexOf(value) > -1) {
          var executor = new Entry.Executor(blocks[i], entity, this);
          this.executors.push(executor);
          executors.push(executor);
        }
      }
      return executors;
    }
  }, {
    key: "getEventMap",
    value: function getEventMap(eventType) {
      return this._eventMap[eventType];
    }
  }, {
    key: "map",
    value: function map(func) {
      this._data.map(func);
    }
  }, {
    key: "tick",
    value: function tick() {
      if (Entry.isTurbo && !this.isUpdateTime) {
        this.isUpdateTime = performance.now();
      }
      var executors = this.executors;
      var watchEvent = this.watchEvent;
      var shouldNotifyWatch = watchEvent.hasListeners();
      var result;
      var executedBlocks = [];
      var loopExecutor = [];
      var _executeEvent = _.partial(Entry.dispatchEvent, 'blockExecute');
      var _executeEndEvent = _.partial(Entry.dispatchEvent, 'blockExecuteEnd');
      for (var i = 0; i < executors.length; i++) {
        var executor = executors[i];
        if (executor.isPause()) {
          continue;
        } else if (!executor.isEnd()) {
          var _ref = executor.scope.block || {},
            view = _ref.view;
          _executeEvent(view);
          result = executor.execute(true);
          if (executor.isLooped) {
            loopExecutor.push(executor);
          }
          if (shouldNotifyWatch) {
            var _result = result,
              blocks = _result.blocks;
            executedBlocks = executedBlocks.concat(blocks);
          }
        } else if (executor.isEnd()) {
          _executeEndEvent(this.board);
          executors.splice(i--, 1);
          if (_.isEmpty(executors)) {
            this.executeEndEvent.notify();
          }
        }
      }
      if (Entry.isTurbo) {
        for (var _i = 0; _i < loopExecutor.length; _i++) {
          var _executor = loopExecutor[_i];
          if (_executor.isPause()) {
            continue;
          } else if (!_executor.isEnd()) {
            var _ref2 = _executor.scope.block || {},
              _view = _ref2.view;
            _executeEvent(_view);
            result = _executor.execute(true);
            if (shouldNotifyWatch) {
              var _result2 = result,
                _blocks = _result2.blocks;
              executedBlocks = executedBlocks.concat(_blocks);
            }
          } else if (_executor.isEnd()) {
            _executeEndEvent(this.board);
            loopExecutor.splice(_i--, 1);
            if (_.isEmpty(loopExecutor)) {
              this.executeEndEvent.notify();
            }
          }
          if (_i === loopExecutor.length - 1 && Entry.tickTime > performance.now() - this.isUpdateTime) {
            _i = -1;
          }
        }
      }
      this.isUpdateTime = 0;
      shouldNotifyWatch && watchEvent.notify(executedBlocks);
      if (result && result.promises) {
        Entry.engine.addPromiseExecutor(result.promises);
      }
    }
  }, {
    key: "removeExecutor",
    value: function removeExecutor(executor) {
      var index = this.executors.indexOf(executor);
      if (index > -1) {
        this.executors.splice(index, 1);
      }
    }
  }, {
    key: "clearExecutors",
    value: function clearExecutors() {
      this.executors.forEach(function (e) {
        return e.end();
      });
      Entry.dispatchEvent('blockExecuteEnd');
      this.executors = [];
    }
  }, {
    key: "clearExecutorsByEntity",
    value: function clearExecutorsByEntity(entity) {
      this.executors.forEach(function (executor) {
        if (executor.entity === entity) {
          executor.end();
        }
      });
    }
  }, {
    key: "addExecutor",
    value: function addExecutor(executor) {
      this.executors.push(executor);
    }
  }, {
    key: "createThread",
    value: function createThread(blocks, index) {
      if (!Array.isArray(blocks)) {
        return console.error('blocks must be array');
      }
      var thread = new Entry.Thread(blocks, this);
      if (index === undefined || index === null) {
        this._data.push(thread);
      } else {
        this._data.insert(thread, index);
      }
      this.changeEvent.notify();
      return thread;
    }
  }, {
    key: "getThreadIndex",
    value: function getThreadIndex(thread) {
      return this._data.indexOf(thread);
    }
  }, {
    key: "getThreadCount",
    value: function getThreadCount() {
      return this._data.length;
    }
  }, {
    key: "cloneThread",
    value: function cloneThread(thread, mode) {
      var newThread = thread.clone(this, mode);
      this._data.push(newThread);
      return newThread;
    }
  }, {
    key: "destroyThread",
    value: function destroyThread(thread) {
      var data = this._data;
      var index = data.indexOf(thread);
      // case of statement thread
      if (~index) {
        data.splice(index, 1);
      }
    }
  }, {
    key: "pushBackThread",
    value: function pushBackThread(thread) {
      this._data.splice(this.getThreadIndex(thread), 1);
      this._data.push(thread);
    }
  }, {
    key: "getThread",
    value: function getThread(index) {
      return this._data[index];
    }
  }, {
    key: "getThreads",
    value: function getThreads() {
      return this._data.slice();
    }
  }, {
    key: "getThreadsByCategory",
    value: function getThreadsByCategory(categoryName) {
      if (!categoryName) {
        return [];
      }
      return this.getThreads().filter(function (t) {
        return _.result(t.getFirstBlock(), 'category') === categoryName;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON(excludeData, option) {
      var params = [false, undefined, excludeData, option];
      return this.getThreads().map(function (t) {
        return t.toJSON.apply(t, params);
      });
    }
  }, {
    key: "countBlock",
    value: function countBlock() {
      return this.getThreads().reduce(function (cnt, thread) {
        return cnt + thread.countBlock();
      }, 0);
    }
  }, {
    key: "moveBy",
    value: function moveBy(x, y) {
      this.getThreads().forEach(function (thread) {
        var _ref3 = thread.getFirstBlock() || {},
          _ref3$view = _ref3.view,
          view = _ref3$view === void 0 ? {} : _ref3$view;
        if (view && view.display) {
          view.moveBy(x, y, false);
        }
      });
      var board = this.board;
      if (board instanceof Entry.BlockMenu) {
        board.updateSplitters(y);
      }
    }
  }, {
    key: "stringify",
    value: function stringify(excludeData) {
      return JSON.stringify(this.toJSON(excludeData));
    }
  }, {
    key: "dominate",
    value: function dominate(thread) {
      thread.view.setZIndex(this._maxZIndex++);
    }
  }, {
    key: "getMaxZIndex",
    value: function getMaxZIndex() {
      return this._maxZIndex;
    }
  }, {
    key: "indexOf",
    value: function indexOf(thread) {
      return this._data.indexOf(thread);
    }
  }, {
    key: "_handleChange",
    value: function _handleChange() {
      var board = _.result(this.view, 'board');
      var event = Entry.creationChangedEvent;
      if (board && event && board.constructor !== Entry.BlockMenu) {
        event.notify();
        if (Entry.codeChangedEvent) {
          Entry.codeChangedEvent.notify();
        }
      }
    }
  }, {
    key: "hasBlockType",
    value: function hasBlockType(type) {
      return this.getThreads().some(function (thread) {
        return thread.hasBlockType(type);
      });
    }
  }, {
    key: "findById",
    value: function findById(id) {
      return this._blockMap[id];
    }
  }, {
    key: "findByType",
    value: function findByType(type) {
      var _this2 = this;
      var id = Object.keys(this._blockMap).find(function (id) {
        var block = _this2._blockMap[id];
        return block.type === type;
      });
      return this._blockMap[id];
    }
  }, {
    key: "findByParamId",
    value: function findByParamId(paramId) {
      return (0, _find2["default"])(this._blockMap, function (block) {
        return (0, _includes2["default"])((block === null || block === void 0 ? void 0 : block.params) || [], paramId);
      });
    }
  }, {
    key: "registerBlock",
    value: function registerBlock(block) {
      this._blockMap[block.id] = block;
    }
  }, {
    key: "unregisterBlock",
    value: function unregisterBlock(_ref4) {
      var id = _ref4.id;
      delete this._blockMap[id];
    }
  }, {
    key: "getByPointer",
    value: function getByPointer(_ref5) {
      var _ref6 = (0, _toArray2["default"])(_ref5),
        pointer = _arrayLikeToArray(_ref6).slice(2);
      var thread = this._data[pointer.shift()];
      var block = thread.getBlock(pointer.shift());
      while (pointer.length) {
        if (!(block instanceof Entry.Block)) {
          if (!block || !block.getValueBlock) {
            console.error("can't get valueBlock", block);
            return block;
          }
          block = block.getValueBlock();
        }
        var type = pointer.shift();
        var index = pointer.shift();
        if (type > -1) {
          var statement = block.statements[type];
          if (index === undefined) {
            return statement;
          } else {
            block = statement.getBlock(index);
          }
        } else if (type === -1) {
          block = block.view.getParam(index);
        }
      }
      return block;
    }
  }, {
    key: "getTargetByPointer",
    value: function getTargetByPointer(_ref7) {
      var _ref8 = (0, _toArray2["default"])(_ref7),
        pointer = _arrayLikeToArray(_ref8).slice(2);
      var thread = this._data[pointer.shift()];
      var block;
      if (pointer.length === 1) {
        block = thread.getBlock(pointer.shift() - 1);
      } else {
        block = thread.getBlock(pointer.shift());
        while (pointer.length) {
          if (!(block instanceof Entry.Block)) {
            block = block.getValueBlock();
          }
          var type = pointer.shift();
          var index = pointer.shift();
          if (type > -1) {
            var statement = block.statements[type];
            if (!pointer.length) {
              if (index === 0) {
                block = statement.view.getParent();
              } else if (index === undefined) {
                block = statement;
              } else {
                block = statement.getBlock(index - 1);
              }
            } else {
              if (index < 0) {
                block = statement;
              } else {
                block = statement.getBlock(index);
              }
            }
          } else if (type === -1) {
            block = block.view.getParam(index);
          }
        }
      }
      return block;
    }
  }, {
    key: "getBlockList",
    value: function getBlockList(excludePrimitive, type) {
      return _.chain(this.getThreads()).map(function (t) {
        return t.getBlockList(excludePrimitive, type);
      }).flatten(true).value();
    }
  }, {
    key: "getBlockListForEventThread",
    value: function getBlockListForEventThread(excludePrimitive, type) {
      return _.chain(this.getThreads()).map(function (t) {
        if (t._event) {
          return t.getBlockList(excludePrimitive, type);
        }
        return [];
      }).flatten(true).value();
    }
  }, {
    key: "removeBlocksByType",
    value: function removeBlocksByType(type) {
      this.getBlockList(false, type).forEach(function (b) {
        return b.doDestroy();
      });
    }
  }, {
    key: "isAllThreadsInOrigin",
    value: function isAllThreadsInOrigin() {
      return this.getThreads().every(function (thread) {
        return thread.isInOrigin();
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.clear();
      this.destroyView();
    }
  }]);
}(), (0, _defineProperty2["default"])(_Code, "waitPauseState", /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
  return _regenerator["default"].wrap(function (_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        if (!Entry.engine.isState('pause')) {
          _context.next = 2;
          break;
        }
        _context.next = 1;
        return Entry.Utils.sleep(100);
      case 1:
        _context.next = 0;
        break;
      case 2:
      case "end":
        return _context.stop();
    }
  }, _callee);
}))), (0, _defineProperty2["default"])(_Code, "funcAsyncExecute", /*#__PURE__*/function () {
  var _ref0 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(funcCode, funcExecutor) {
    var _promises,
      _args3 = arguments;
    return _regenerator["default"].wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _promises = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : [];
          _context3.next = 1;
          return Promise.all(_promises);
        case 1:
          if (!Entry.engine.isState('pause')) {
            _context3.next = 3;
            break;
          }
          _context3.next = 2;
          return _Code.waitPauseState();
        case 2:
          return _context3.abrupt("return", _Code.funcAsyncExecute(funcCode, funcExecutor, _promises));
        case 3:
          if (Entry.engine.isState('run')) {
            _context3.next = 4;
            break;
          }
          funcCode.removeExecutor(funcExecutor);
          return _context3.abrupt("return", Entry.STATIC.BREAK);
        case 4:
          return _context3.abrupt("return", new Promise(function (resolve, reject) {
            requestAnimationFrame(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
              var result, _ref10, _ref10$promises, promises, _t, _t2;
              return _regenerator["default"].wrap(function (_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    result = funcExecutor.execute();
                    _ref10 = result || {}, _ref10$promises = _ref10.promises, promises = _ref10$promises === void 0 ? [] : _ref10$promises;
                    if (funcExecutor.isEnd()) {
                      _context2.next = 5;
                      break;
                    }
                    if (!promises.length) {
                      _context2.next = 4;
                      break;
                    }
                    _context2.prev = 1;
                    _t = resolve;
                    _context2.next = 2;
                    return _Code.funcAsyncExecute(funcCode, funcExecutor, promises);
                  case 2:
                    return _context2.abrupt("return", _t(_context2.sent));
                  case 3:
                    _context2.prev = 3;
                    _t2 = _context2["catch"](1);
                    return _context2.abrupt("return", reject(_t2));
                  case 4:
                    funcCode.callStackLength--;
                    funcCode.removeExecutor(funcExecutor);
                    return _context2.abrupt("return", resolve(Entry.STATIC.CONTINUE));
                  case 5:
                    return _context2.abrupt("return", resolve());
                  case 6:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[1, 3]]);
            })));
          }));
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function (_x, _x2) {
    return _ref0.apply(this, arguments);
  };
}()), (0, _defineProperty2["default"])(_Code, "getAsyncParamsData", /*#__PURE__*/function () {
  var _ref11 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(scope) {
    var values, isPromise;
    return _regenerator["default"].wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          values = scope.getParams();
          isPromise = values.some(function (value) {
            return value instanceof Promise;
          });
          if (isPromise) {
            _context4.next = 1;
            break;
          }
          scope.values = values;
          _context4.next = 3;
          break;
        case 1:
          _context4.next = 2;
          return Promise.all(values);
        case 2:
          scope.values = _context4.sent;
        case 3:
          return _context4.abrupt("return", scope.getValue('VALUE', scope));
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function (_x3) {
    return _ref11.apply(this, arguments);
  };
}()), (0, _defineProperty2["default"])(_Code, "funcValueAsyncExecute", /*#__PURE__*/function () {
  var _ref12 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(funcCode, funcExecutor) {
    var _promises,
      _args6 = arguments;
    return _regenerator["default"].wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _promises = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : [];
          _context6.next = 1;
          return Promise.all(_promises);
        case 1:
          if (!Entry.engine.isState('pause')) {
            _context6.next = 3;
            break;
          }
          _context6.next = 2;
          return _Code.waitPauseState();
        case 2:
          return _context6.abrupt("return", _Code.funcValueAsyncExecute(funcCode, funcExecutor, _promises));
        case 3:
          if (Entry.engine.isState('run')) {
            _context6.next = 5;
            break;
          }
          funcCode.removeExecutor(funcExecutor);
          _context6.next = 4;
          return _Code.getAsyncParamsData(funcExecutor.result);
        case 4:
          return _context6.abrupt("return", _context6.sent);
        case 5:
          return _context6.abrupt("return", new Promise(function (resolve, reject) {
            requestAnimationFrame(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
              var result, _ref14, _ref14$promises, promises, _t3, _t4, _t5, _t6;
              return _regenerator["default"].wrap(function (_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.prev = 0;
                    result = funcExecutor.execute();
                    _ref14 = result || {}, _ref14$promises = _ref14.promises, promises = _ref14$promises === void 0 ? [] : _ref14$promises;
                    if (funcExecutor.isEnd()) {
                      _context5.next = 5;
                      break;
                    }
                    if (!promises.length) {
                      _context5.next = 4;
                      break;
                    }
                    _context5.prev = 1;
                    _t3 = resolve;
                    _context5.next = 2;
                    return _Code.funcValueAsyncExecute(funcCode, funcExecutor, promises);
                  case 2:
                    return _context5.abrupt("return", _t3(_context5.sent));
                  case 3:
                    _context5.prev = 3;
                    _t4 = _context5["catch"](1);
                    return _context5.abrupt("return", reject(_t4));
                  case 4:
                    funcCode.callStackLength--;
                    funcCode.removeExecutor(funcExecutor);
                  case 5:
                    _t5 = resolve;
                    _context5.next = 6;
                    return _Code.getAsyncParamsData(funcExecutor.result);
                  case 6:
                    _t5(_context5.sent);
                    _context5.next = 8;
                    break;
                  case 7:
                    _context5.prev = 7;
                    _t6 = _context5["catch"](0);
                    reject(_t6);
                  case 8:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5, null, [[0, 7], [1, 3]]);
            })));
          }));
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function (_x4, _x5) {
    return _ref12.apply(this, arguments);
  };
}()), (0, _defineProperty2["default"])(_Code, "funcRestExecute", /*#__PURE__*/function () {
  var _ref15 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(funcCode, funcExecutor) {
    return _regenerator["default"].wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          if (Entry.engine.isState('run')) {
            _context8.next = 2;
            break;
          }
          funcCode.removeExecutor(funcExecutor);
          _context8.next = 1;
          return _Code.getAsyncParamsData(funcExecutor.result);
        case 1:
          return _context8.abrupt("return", _context8.sent);
        case 2:
          return _context8.abrupt("return", new Promise(function (resolve, reject) {
            requestAnimationFrame(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
              var result, _ref17, _ref17$promises, promises, _t7, _t8, _t9, _t0, _t1;
              return _regenerator["default"].wrap(function (_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.prev = 0;
                    result = funcExecutor.execute();
                    _ref17 = result || {}, _ref17$promises = _ref17.promises, promises = _ref17$promises === void 0 ? [] : _ref17$promises;
                    if (funcExecutor.isEnd()) {
                      _context7.next = 6;
                      break;
                    }
                    if (!promises.length) {
                      _context7.next = 4;
                      break;
                    }
                    _context7.prev = 1;
                    _t7 = resolve;
                    _context7.next = 2;
                    return _Code.funcValueAsyncExecute(funcCode, funcExecutor, promises);
                  case 2:
                    return _context7.abrupt("return", _t7(_context7.sent));
                  case 3:
                    _context7.prev = 3;
                    _t8 = _context7["catch"](1);
                    return _context7.abrupt("return", reject(_t8));
                  case 4:
                    _t9 = resolve;
                    _context7.next = 5;
                    return _Code.funcRestExecute(funcCode, funcExecutor);
                  case 5:
                    return _context7.abrupt("return", _t9(_context7.sent));
                  case 6:
                    _t0 = resolve;
                    _context7.next = 7;
                    return _Code.getAsyncParamsData(funcExecutor.result);
                  case 7:
                    _t0(_context7.sent);
                    funcCode.removeExecutor(funcExecutor);
                    _context7.next = 9;
                    break;
                  case 8:
                    _context7.prev = 8;
                    _t1 = _context7["catch"](0);
                    reject(_t1);
                  case 9:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7, null, [[0, 8], [1, 3]]);
            })));
          }));
        case 3:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function (_x6, _x7) {
    return _ref15.apply(this, arguments);
  };
}()), _Code);